// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"402":"f58f013b","787":"0236cad6"}[chunkId] + ".chunk.js";
};